import { Select } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const SelectComp = styled(Select)({
    height: 36,

    margin: '0 5px',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--borderColor)'
    },
    '& .MuiSelect-select:focus': {
        backgroundColor: 'white',
        borderColor: 'var(--borderColor)'
    },

    '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--borderColor)',
            borderWidth: '1px'
        }

    }
});
